import { render } from "./CategoryOverview.vue?vue&type=template&id=53ca7d0a"
import script from "./CategoryOverview.vue?vue&type=script&lang=js"
export * from "./CategoryOverview.vue?vue&type=script&lang=js"

import "./CategoryOverview.vue?vue&type=style&index=0&id=53ca7d0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__